import { call, put } from "redux-saga/effects";
import { userApi } from "@services/api";
import { getInstructorProfileActions } from "../slices";
import { isSubscribedAction } from "@redux/actions";

function* getInstructorProfileWorker({ payload }) {
  // yield delay(300);
  try {
    yield put(getInstructorProfileActions.reset());
    yield put(getInstructorProfileActions.pending());
    const response = yield call(userApi.getProfile, payload);
    yield put(getInstructorProfileActions.success(response));
    yield put(isSubscribedAction(payload.userId));
    // TODO: handle callback | onSuccess
  } catch (error) {
    yield put(getInstructorProfileActions.failure(error));
    // TODO: handle callback | onFailure
  }
}

export { getInstructorProfileWorker };
